export default {
  async fetch({ dispatch, commit, rootGetters }, args = {}) {
    commit("SET_LOADING", true);
    try {
      const instanceId = args.instanceId ?? rootGetters["application/getMainInstanceId"];
      commit("SET_INSTANCE_ID", instanceId);
      await dispatch("setUsers");
      await dispatch("setAgencies");
      await dispatch("setRoles");
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async setUsers({ commit, state, rootGetters }) {
    const { page, sortBy, orderBy, search: filter } = state;
    const size = rootGetters["application/getPageSize"];
    try {
      const users = await this.$services.user.fetch({ size, page, sortBy, orderBy, filter });
      commit("SET_USERS", users);
    } catch (error) {
      throw new Error(error);
    }
  },

  async fetchUser({ commit }, id) {
    try {
      const editingUser = await this.$services.user.fetchOne(id);
      commit("SET_EDITING_USER", editingUser);
    } catch (error) {
      throw new Error(error);
    }
  },

  async addUser({ commit }, user) {
    try {
      const createdUser = await this.$services.user.create(user);
      commit("ADD_USER", createdUser);
      this.$feedback.ok("feedback.create.user.ok");
    } catch (error) {
      const { error: prefix, message } = error.response.data;
      this.$feedback.error(`${prefix}${message}`);
    }
  },

  async setUser({ commit }, { savedUser, id }) {
    try {
      const user = await this.$services.user.patch(id, savedUser);
      commit("SET_USER", user);
      this.$feedback.ok("feedback.update.user.ok");
    } catch (error) {
      const data = error.response?.data;
      if (data?.error && data?.message) {
        this.$feedback.error(`${data.error}${data.message}`);
      } else {
        this.$feedback.error("feedback.update.user.error");
      }
    }
  },

  async deleteUser({ commit }, id) {
    try {
      await this.$services.user.remove(id);
      commit("DELETE_USER", id);
      this.$feedback.ok("feedback.delete.user.ok");
    } catch {
      this.$feedback.error("feedback.delete.user.error");
    }
  },

  async setAgencies({ commit, state }) {
    try {
      const agencies = await this.$services.user.fetchAgencies(state.instanceId);
      commit("SET_AGENCIES", agencies.collection);
    } catch (error) {
      throw new Error(error);
    }
  },

  async setRoles({ commit }) {
    try {
      const roles = await this.$services.user.fetchRoles();
      commit("UPDATE_ROLES", roles);
    } catch (error) {
      throw new Error(error);
    }
  },

  async prepareCsv({ dispatch, commit }, params) {
    try {
      await this.$services.user.preparecsv(params);
      await dispatch("application/setDownloads", {}, { root: true });
      commit("application/SET_IS_WAITING_FOR_DOWNLOADS", true, { root: true });
      this.$feedback.ok("generic.download.ok");
    } catch {
      this.$feedback.error("generic.download.error");
    }
  },
};
